// Signal emitted after a successful save so other components can refetch.
// Same pattern as the other v2 sections' events.js files. Food preferences is
// review-only inline-edited with debounced saves, so this fires once the
// server confirms a full-doc PUT.
export const FP_V2_REFRESH = "fp-v2:refresh";

// Transcript-flow bridge: emitted by CapturedSections when an AI food-
// preference capture arrives. Food preferences intentionally has NO
// right-rail card (unlike every other section) — the captured
// selection instead merges directly into the middle-column form's
// local state, mirroring "the AI picked this for you" the same way as
// a user-selected chip. Payload matches the captured-item shape:
// { kind: "likes"|"dislikes"|"restrictions"|"limitations", ingredient }.
export const FP_V2_AI_INJECT = "fp-v2:ai-inject";
